import {
  createContext,
  useState,
  type Dispatch,
  type ReactNode,
  type SetStateAction,
} from 'react';
import type { ReviewableSignal } from '../../signal-review/types';

export interface SignalReviewContextValue {
  signals: ReviewableSignal[];
  setSignals: Dispatch<SetStateAction<ReviewableSignal[]>>;
}

export const SignalReviewContext =
  createContext<SignalReviewContextValue | null>(null);

interface SignalReviewProviderProps {
  children: ReactNode;
}

export const SignalReviewProvider = ({
  children,
}: SignalReviewProviderProps) => {
  const [signals, setSignals] = useState<ReviewableSignal[]>([]);

  return (
    <SignalReviewContext.Provider value={{ signals, setSignals }}>
      {children}
    </SignalReviewContext.Provider>
  );
};
